jQuery( $ => {
	/**
	 * Trigger accordion.
	 */
	$( '.accordion-content .accordion-title' ).click( function() {
		const parentEl = $( this ).closest( '.accordion-item' );
		toggleProductBlock( parentEl );
	} );

	/**
	 * Toggles an accordion item.
	 *
	 * @param {Object}  blockEl   the outer block element.
	 * @param {boolean} forceOpen wether it should be forced to open.
	 */
	function toggleProductBlock( blockEl, forceOpen = false ) {
		const trigger = blockEl.find( '.accordion-title' );
		const content = blockEl.find( '.accordion-inner-content' );

		if ( forceOpen ) {
			blockEl.removeClass( 'accordion-hidden' );
			trigger.attr( 'aria-expanded', 'true' );
			content.attr( 'aria-hidden', 'false' );
			return;
		}
		// Toggle class for the block which sets visibility.
		blockEl.toggleClass( 'accordion-hidden' );
		// Aria for the h2 trigger element.
		trigger.attr( 'aria-expanded', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
		// Aria for the hidden content.
		content.attr( 'aria-hidden', ( i, attr ) => {
			return 'true' === attr ? 'false' : 'true';
		} );
	}
} );
